import React from "react";
import ReactDOM from "react-dom";
import GlobalStyle from "./components/GlobalStyle";
import App from "./components/app";
import "antd/dist/antd.less";
import "./assets/fonts/fonts.css";
import "./locales";
import { GoogleOAuthProvider } from "@react-oauth/google";
const veoliaClientId = window["env"].GOOGLE.VEOLIA_CLIENT_ID;
ReactDOM.render(<React.StrictMode>
    <GlobalStyle />
    <GoogleOAuthProvider clientId={veoliaClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>, document.getElementById("root"));
